// extracted by mini-css-extract-plugin
module.exports = {"itemImageArea":"ImageCover_itemImageArea__1kbFp","itemImage":"ImageCover_itemImage__2hzW8"};